import { useQuery } from "@tanstack/react-query";
import { getTokens } from "../../utils/tokens";
import { getInAppNotificationsUnreadCountAPI } from "../../api/userApi";
import { queryKeys } from "../keys";

export type InAppUnreadCountData = {
  unreadCount: number;
  hasUnread: boolean;
};

export function useInAppNotificationsUnreadCountQuery() {
  const hasToken = !!getTokens()?.access_token;

  return useQuery({
    queryKey: queryKeys.inAppNotificationsUnreadCount,
    enabled: hasToken,
    queryFn: async (): Promise<InAppUnreadCountData> => {
      const res = await getInAppNotificationsUnreadCountAPI();
      const unreadCount = Number(res?.data?.unreadCount || 0);
      const hasUnread = Boolean(res?.data?.hasUnread) || unreadCount > 0;
      return { unreadCount, hasUnread };
    },
    staleTime: 5_000,
    refetchInterval: 5_000,
    refetchIntervalInBackground: true,
  });
}

